<template>
  <div class="pass-calendar">
    <div class="pass-calendar-content">
      <h1>{{ $t('Beurt reserveren') }}</h1>
      <div v-if="passReservations && Object.values(passReservations).length">
        <h2>{{ $t('Mijn reservaties') }}</h2>
        <Planning v-for="(data, index) in passReservations" :key="index" :data="data" @cancel="cancel" />
      </div>
      <div class="pass-calendar-wrapper-calendar-events">
        <div>
          <h2>{{ $t('Kies een datum') }}</h2>
          <Calendar :events="events" v-model="selectedDay" />
        </div>
        <div v-if="selectedDay">
          <h2>{{ $t('Kies een tijdstip') }}</h2>
          <div class="events" v-if="selectedDay.events && selectedDay.events.length">
            <PassCalendarEvent v-for="(event, index) in selectedDay.events" :key="index" v-model="selectedReservation" :event="event" />
          </div>
          <Alert :title="$t('Geen sessies gevonden')" v-else>{{ $t('Geen sessies op deze dag, kies een andere dag die aangeduid staat als beschikbaar.') }}</Alert>
        </div>
      </div>
    </div>
    <Card primary fill class="reservation" :title="$t('Jouw reservatie')">
      <List>
        <ListItem v-if="selectedUser" icon="id-badge">{{ selectedUser.name }}</ListItem>
        <ListItem v-if="selectedDay" icon="calendar">{{ selectedDay.date.format('dddd DD MMMM YYYY') }}</ListItem>
        <ListItem v-if="selectedReservation" icon="clock">{{ selectedReservation.startTime }} - {{ selectedReservation.endTime }}</ListItem>
        <ListItem icon="euro-sign">{{ tariff.price|money(false) }}/{{ $t('sessie') }}</ListItem>
      </List>
      <Alert type="danger" v-if="selectedDay && selectedReservation && selectedReservation.availability === 0 && !isSelectedReserved" :title="$t('Sessie volzet')">
        {{ $t('Deze sessie is volzet, kies een andere sessie') }}
      </Alert>
      <Button v-else-if="!user" danger fill @click="$router.push({ name: 'Login' })">{{ $t('Inloggen') }}</Button>
      <UserSelect success v-else-if="!selectedUser">{{ $t('Kies gebruiker') }}</UserSelect>
      <Alert type="danger" v-else-if="!isWithinCredit && !isSelectedReserved" :title="$t('Ontoereikend saldo')">
        <p>{{ $t(passReloadDeactivated ? 'Vraag je clubbeheerder om saldo toe te voegen aan je account.' : 'Herlaad je beurtenkaart voor deze beurt kan reserveren.') }}</p>
        <Button icon="battery-three-quarters" @click="$router.push({ name: 'PassReload', params: { club: $route.params.club } })" v-if="!passReloadDeactivated">{{ $t('Herlaad beurtenkaart') }}</Button>
      </Alert>
      <Button v-else-if="selectedDay && selectedReservation && !isSelectedReserved" success fill icon="plus" @click="reserve">{{ $t('Reserveren') }}</Button>
      <Button v-else-if="selectedDay && selectedReservation && isSelectedReserved && selectedReservation.allow_cancellation" danger fill @click="cancel">{{ $t('Annuleer reservatie') }}</Button>
      <Button v-else-if="selectedDay && selectedReservation && isSelectedReserved && !selectedReservation.allow_cancellation" disabled danger fill>{{ $t('Annulatie periode verstreken') }}</Button>
    </Card>
  </div>
</template>

<script>
import Calendar from '../Calendar/Index'
import Card from '../Core/Card'
import Button from '../Core/Button'
import Alert from '../Core/Alert'
import PassCalendarEvent from './PassCalendarEvent'
import List from '../Core/List'
import ListItem from '../Core/ListItem'
import UserSelect from '../Core/UserSelect'
import api from '../../api'
import Planning from "../Core/Planning.vue";
export default {
  name: 'PassCalendar',
  components: {
    Planning,
    UserSelect,
    ListItem,
    List,
    PassCalendarEvent,
    Alert,
    Button,
    Card,
    Calendar
  },
  props: {
    events: Array,
    course: Object,
    tariff: Object
  },
  data () {
    return {
      selectedDay: false,
      selectedReservation: false,
      credit: 0,
      passReloadDeactivated: false
    }
  },
  async mounted () {
    await this.fetchData()
  },
  computed: {
    club () {
      return this.$store.getters['club/club']
    },
    user () {
      return this.$store.getters['user/user']
    },
    selectedUser () {
      return this.$store.getters['user/selectedUser']
    },
    isSelectedReserved () {
      if (!this.selectedReservation) {
        return false
      }
      return this.selectedReservation.reservations.find(reservation => {
        return parseInt(reservation.uid) === parseInt(this.selectedUser.uid)
      })
    },
    isWithinCredit () {
      return this.tariff.price <= this.credit
      // Todo get user pass, check if user pass > session, if not show ontoereikend saldo
    },
    isSelectedAvailable () {
      if (!this.selectedReservation) {
        return false
      }

      if (this.isSelectedReserved) {
        return false
      }

      return this.selectedReservation.availability > 0
    },
    passReservations () {
      if (!this.events.length) return {}

      return this.events.filter((event) => event.reservations.length && event.reservations.find((reservation) => reservation.uid === this.selectedUser.uid)).map((event) => {
        return {
          date: event.date.format('DD MMM YYYY'),
          sessions: event.reservations.filter((reservation) => reservation.uid === this.selectedUser.uid).map((reservation) => {
            return {
              ...event,
              from: event.startTime,
              to: event.endTime,
              user: reservation.name,
              club: this.club,
              label: this.course.title,
              canCancel: event.allow_cancellation
            }
          })
        }
      })
    }
  },
  watch: {
    selectedDay () {
      this.selectedReservation = false
      // Select the first one if only one
      if (this.selectedDay && this.selectedDay.events && this.selectedDay.events.length === 1) {
        this.selectedReservation = this.selectedDay.events[0]
      }
      if (this.selectedDay) {
        this.$router.replace({
          query: {
            pass: this.$route.query.pass,
            date: this.selectedDay.date.unix(),
            noScroll: 1
          }
        })
      }
    }
  },
  methods: {
    async reserve () {
      this.$emit('submit', {
        course: this.course.nid,
        tariff: this.tariff.nid,
        session: this.selectedReservation.nid,
        uid: this.selectedUser.uid
      })
    },
    async cancel (session = false) {
      const sessionNid = session && session.nid ? session.nid : this.selectedReservation.nid
      this.$emit('cancel', {
        tariff: this.tariff.nid,
        session: sessionNid,
        uid: this.selectedUser.uid
      })
      this.selectedDay = false
      this.selectedReservation = false
    },
    async fetchData () {
      const response = await api.get('get_public_passes_data', {
        club: this.club.nid
      })
      this.credit = response.data.credit
      this.passReloadDeactivated = response.data.pass_reload_deactivated
    }
  }
}
</script>

<style lang="scss">
.pass-calendar {
  display: flex;
  margin-bottom: 1rem;

  & > div:not(:last-child) {
    margin-right: 1rem;
  }
}
.pass-calendar-content {
  flex-grow: 1;
}
.pass-calendar-wrapper-calendar-events {
  display: grid;
  grid-gap: 1rem;
}
.pass-calendar .reservation {
  width: auto;
}
@media screen and (max-width: 768px) {
  .pass-calendar {
    flex-wrap: wrap;
  }
}

@media screen and (min-width: 768px) {
  .pass-calendar-wrapper-calendar-events {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
